import React from 'react'

import { Button } from 'primereact/button'

export default function CardDownload({
  show,
  title,
  subtitle,
  buttonLabel = 'Download',
  buttonIcon = 'pi pi-download',
  onClick,
  disabled = false,
  showDivider = true
}) {
  if (!show) return null

  return (
    <>
      {showDivider && <div style={{ borderTop: '1px solid #e5e7eb', marginTop: 6 }} />}

      <div
        style={{
          border: '1px solid #e5e7eb',
          borderRadius: 10,
          padding: 12,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: 6
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <b>{title}</b>
          {subtitle ? <span style={{ color: '#6b7280' }}>{subtitle}</span> : null}
        </div>

        <Button
          icon={buttonIcon}
          label={buttonLabel}
          className="p-button-outlined"
          onClick={onClick}
          disabled={disabled}
        />
      </div>
    </>
  )
}
